import React from 'react';
import Typed from "react-typed";
import {BottomNavigation, BottomNavigationAction} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

import LinkedIn from "../Assets/Images/linkedin-icon.png";
import Github from "../Assets/Images/github-icon.png";
import Stackoverflow from "../Assets/Images/stackoverflow-icon.png";
import Medium from "../Assets/Images/medium-icon.png";
import Hackerrak from "../Assets/Images/hackerrank-icon.png"

import {
    Typography,
    Avatar,
    Grid,
    Box
} from "@material-ui/core";

import avatar from "../Assets/Images/avatar.png";

//CSS Styles
const useStyles = makeStyles(theme=>({
    avatar:{
        width:theme.spacing(20),
        height:theme.spacing(20),
        marginTop:theme.spacing(-13),
        marginBottom: theme.spacing(0),
        boxShadow: "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px"
    },
    title:{
        color:"#05acd3",
        cursor:"context-menu",
        fontFamily: "Raleway",
        fontSize: "2.4rem",
        marginTop: "2.2rem",
        [theme.breakpoints.down(1369)]:{
            fontSize: "1.7rem"
        }
    },
    subTitle:{
        color:"#ff7f50",
        cursor:"context-menu",
        fontFamily: "PT Mono",
        fontSize: "1.9rem",
        marginBottom: "3rem",
        marginTop: "1rem",
        lineSpacing: "0.372rem",
        [theme.breakpoints.down(1369)]:{
            fontSize: "1.4rem"
        }
    },
    typedContainer:{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        textAlign: "center",
        zIndex: 1,
        [theme.breakpoints.down(1033)]: {
            transform: "translate(-50%, -50%)",
        }
    },
    icon:{
        margin: "0rem 1.1rem 0.5rem", 
        height:"60px",
        borderRadius: "12px",
        "&:hover":{
            boxShadow: "rgba(255,255,255, 0.1) 0px 1px 0px, rgba(255,255,255, 0.1) 0px 8px 24px, rgba(255,255,255, 0.1) 0px 16px 48px",
            transform: "scale(1.2)"
        },
        transition: "transform 200ms ease-in-out",
        [theme.breakpoints.down(1033)]: {
            height:"40px"
        }

    }
}))

const Header = () => {

    const classes = useStyles();

    return (
        <Box className={classes.typedContainer} style={{minWidth:"480px"}}>
            <Grid container justify="center">
            <a href="/"><Avatar src={avatar} alt="Pawara Sirwardhane"  className={classes.avatar}/></a>
            </Grid>
            <Typography className={classes.title}>
                <Typed 
                    strings={["Hi! Welcome To My Website"]}
                    typeSpeed={50}
                    />
            </Typography>
            <div>
            <Typography className={classes.subTitle}>
            <span>{"< "}</span>
                <Typed 
                    strings={["Web Development", "React JS", "ASP .NET Core", "MVC", "Azure", "AWS", "Git", "Trello", "Graphic Designing", "FreeCAD", "Blender"]}
                    typeSpeed={70}
                    loop
                    />
                    <span>{">"}</span>
            </Typography>
            </div>
            <div>
                <a 
                    href="https://www.linkedin.com/in/pawara73/" 
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        className={classes.icon}
                        src={LinkedIn}
                        title="Visit Pawara's LinkedIn Profile"
                        alt="LinkedIn icon"
                    />
                </a>
                <a 
                    href="https://github.com/aLLUPS" 
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        className={classes.icon}
                        src={Github}
                        title="Visit Pawara's Github Profile"
                        alt="Github icon"
                    />
                </a>
                <a 
                    href="https://stackoverflow.com/users/12215054/pawara-siriwardhane" 
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        className={classes.icon}
                        src={Stackoverflow}
                        title="Visit Pawara's StaclOverflow Profile"
                        alt="Stackoverflow icon"
                    />
                </a>
                <a 
                    href="https://pawara73.medium.com/" 
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        className={classes.icon}
                        src={Medium}
                        title="Visit Pawara's Medium Profile"
                        alt="Medium icon"
                    />
                </a>
                <a 
                    href="https://www.hackerrank.com/Pawara_S_18" 
                    target="_blank"
                    rel="noreferrer"
                >
                    <img
                        className={classes.icon}
                        src={Hackerrak}
                        title="Visit Pawara's Hackerrank Profile"
                        alt="Hackerrank icon"
                    />
                </a>
                
            </div>
        </Box>
    )
}

export default Header;
